import type { SxProps, Theme } from "@mui/material/styles";

export const markdownSx: SxProps<Theme> = {
  "& p": {
    m: 0,
    "& + p": { mt: 1.5 },
  },
  "& ul, & ol": {
    m: 0,
    pl: 3,
    "& + p": { mt: 1.5 },
  },
  "& li": {
    mb: 0.5,
  },
  "& li > p": {
    m: 0,
  },
  "& code": {
    fontFamily: '"Fira Code", "Consolas", "Monaco", monospace',
    fontSize: "0.875em",
    bgcolor: "rgba(0, 0, 0, 0.06)",
    px: 0.75,
    py: 0.25,
    borderRadius: 0.5,
  },
  "& pre": {
    m: 0,
    mt: 1,
    mb: 1,
    "& > code": {
      display: "block",
      bgcolor: "rgba(0, 0, 0, 0.06)",
      p: 2,
      borderRadius: 1,
      overflowX: "auto",
      fontSize: "0.85em",
    },
  },
  "& table": {
    borderCollapse: "collapse",
    my: 1.5,
    width: "100%",
  },
  "& th, & td": {
    border: "1px solid",
    borderColor: "divider",
    px: 1.5,
    py: 0.75,
    textAlign: "left",
  },
  "& th": {
    fontWeight: 600,
    bgcolor: "rgba(0, 0, 0, 0.04)",
  },
  "& h1, & h2, & h3, & h4": {
    mt: 2,
    mb: 1,
    "&:first-of-type": { mt: 0 },
  },
  "& h1": { fontSize: "1.5em", fontWeight: 600 },
  "& h2": { fontSize: "1.3em", fontWeight: 600 },
  "& h3": { fontSize: "1.15em", fontWeight: 600 },
  "& h4": { fontSize: "1em", fontWeight: 600 },
  "& a": {
    color: "primary.main",
    textDecoration: "underline",
  },
  "& blockquote": {
    m: 0,
    my: 1.5,
    pl: 2,
    borderLeft: "3px solid",
    borderColor: "divider",
    color: "text.secondary",
  },
  "& hr": {
    border: "none",
    borderTop: "1px solid",
    borderColor: "divider",
    my: 2,
  },
  "& img": {
    maxWidth: "100%",
  },
};
